import plusIcon from '@disy/cadenza-icons/plus.svg';

import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import { icon } from 'cadenza/utils/icon/icon';
import { createDrawLayer, getDrawModifyInteraction, getGeometryType } from 'cadenza/map/layer-actions/feature-edit-geometry';
import { CreateNewFeaturePanel } from 'cadenza/map/create-new-feature-panel/create-new-feature-panel';
import { isPanelAlreadyOpen } from 'cadenza/map/feature-attributes-panel/abstract-feature-panel';
import { addSidebar } from 'cadenza/map/map-utils';

import i18n from './layer-actions.properties';
import { LayerAction } from './layer-action';

export class FeatureAcquisition extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('featureEditor.createNewFeature'),
      icon: icon(plusIcon)
    }, options));
    this.#map = options.map;
  }

  executeSync () {
    const geometryType = getGeometryType(this.layer);
    const drawLayer = createDrawLayer(geometryType, this.#map.get(MapProperty.DEFAULT_STYLES));
    drawLayer.setMap(this.#map);
    this.#map.set(MapProperty.PRIMARY_INTERACTION, getDrawModifyInteraction(this.#map, geometryType, drawLayer));

    const createNewFeaturePanel = new CreateNewFeaturePanel({
      map: this.#map,
      layer: this.layer,
      drawLayerSource: drawLayer.getSource(),
      geometryType,
      onClose: () => this.checkIfActionIsSupported()
    });
    addSidebar(createNewFeaturePanel);
    this.checkIfActionIsSupported();
  }

  isSupportedSync ({ isEditingLayer }) {
    if (!isEditingLayer && !isPanelAlreadyOpen()) {
      const selectedLayer = this.#map.get(MapProperty.SELECTED_LAYER);
      if (this._layer.get(LayerProperty.HAS_FEATURES) && this._layer === selectedLayer) {
        return this._layer.get(LayerProperty.SUPPORTS_FEATURE_CREATION);
      }
    }
    return false;
  }

}
